const setCookiesEnabled = (state, payload) => ({
  ...state,
  cookiesEnabled: payload,
});

export default setCookiesEnabled;
